import React from 'react';

import ReactDOM from 'react-dom';
import '@athena/forge/dist/forge.css'; // Use compiled Forge styles
import './css/index.css'; // Add in App-specific styles after Forge ones

import registerServiceWorker from './registerServiceWorker';

import App from './App'

  

ReactDOM.render(<App/>,document.getElementById('root'));
registerServiceWorker();
